<template>
  <div class="lf marketing ml mtt">

    <div class="marketing-wrap">
      <div class="marketing-inner">
        <div id="myChartConsump" style="width:100%;height:100%;"></div>
      </div>
    </div>
    <title-h3 :titlemsg="titlemsg"></title-h3>
  </div>

</template>

<script>
  import title from '../title';
  export default{
    name:'consumption',
    data(){
      return{
        titlemsg:'销量分类排行'
      }
    },
    mounted(){
      this.drawLine();
    },
    methods: {
      drawLine(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChartConsump'));
        // 绘制图表
        var option;

        option = {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['分类', '销量'],
            textStyle:{
                color:'#fff'
            },
            top:'4%',
            left:'45%'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          // toolbox: {
          //   feature: {
          //     saveAsImage: {}
          //   }
          // },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: ['2月', '3月', '4月', '5月', '6月', '7月'],
            axisLabel: {
              textStyle: {
                color: '#fff'
              }
            },
            axisLine: {
              show: true,
              lineStyle:{
                color:'#fff'
              }
            },
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              textStyle: {
                color: '#fff'
              }
            },
            axisLine: {
              show: true,
              lineStyle:{
                color:'#fff'
              }
            },
          },
          series: [
            {
              name: '分类',
              type: 'line',
              stack: 'Total',
              data: [120, 132, 101, 134, 90, 230, 210]
            },
            {
              name: '销量',
              type: 'line',
              stack: 'Total',
              data: [820, 932, 901, 934, 1290, 1330, 1320]
            }
          ]
        };

        option && myChart.setOption(option);
      }
    },
    components:{
      'title-h3':title
    }
  }

</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/marketing/consumption.vue